export const MetricAPI = {
  create: openapiStrictFetch({
    url: 'v2/metrics',
    method: HTTPMethod.post,
  }),
};
